export default "__VITE_ASSET__CBMyiiOu__"